// 货币格式
const moneyFormat = "US${{amount}}";

function formatMoney (cents, format) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  let value = '';
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || moneyFormat;

  function formatWithDelimiters (
    number,
    precision = 2,
    thousands = ',',
    decimal = '.'
  ) {
    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    const parts = number.split('.');
    const dollarsAmount = parts[0].replace(
      /(\d)(?=(\d\d\d)+(?!\d))/g,
      `$1${thousands}`
    );
    const centsAmount = parts[1] ? decimal + parts[1] : '';

    return dollarsAmount + centsAmount;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
}


class BundleItem extends HTMLElement {
  constructor() {
    super();
    this.isCompleted = true;
    this.product = {};
    this.currentVariant = {};
    this.selectsEl = {
      inputEl: this.querySelector('[name="id"]'),
      labelEl: this.querySelector("label"),
      tagsEl: this.querySelectorAll("[data-tag]"),
      titleEl: this.querySelector("[data-title]"),
      priceEl: this.querySelector("[data-price]"),
      discountPriceEl: this.querySelector("[data-discount-price]") || undefined,
      comparePriceEl: this.querySelector("[data-compare-price]"),
      featuredImageEl: this.querySelector("[data-featured-image]"),
      propertiesEl: this.querySelectorAll("[data-properties]"),
      productCarouselEl: this.querySelector("product-carousel"),
      quantityEl: this.querySelector('[data-type="quantity"]'),
    };
    this.customEvent = (eventName = "customEventName", detail = {}) =>
      new CustomEvent(eventName, {
        detail: detail,
        bubbles: true,
        cancelable: false,
      });
    this.init();
  }
  static get observedAttributes () {
    return ["data-id"];
  }
  init () {
    this.initProductData();
    this.handelEvents();
  }
  // 获取产品数据
  initProductData () {
    const prodductJson = this.querySelector('[type="application/json"]');

    if (prodductJson) {
      this.product = JSON.parse(prodductJson.innerHTML);
    }
  }

  // 绑定事件
  handelEvents () {
    const { quantityEl } = this.selectsEl;

    this.addEventListener("change", (el) => {
      if (this.isCompleted) {
        this.isCompleted = false;

        const { target } = el;
        const { checked, value } = target;
        const { type } = target.dataset;

      
        // 多选
        if (type == "checkbox") {
          const currentVariant = this.getCurrentVariant(value);
          this.setAttribute("data-id", currentVariant.id);

          // // 数量在产品选中的时候开启编辑
          quantityEl?.toggleAttribute("disabled", !checked);
          // quantityEl?.classList.toggle("pointer-events-none", !checked);

          // // 更新价格、对比价格、标题、图片
          checked === false ? currentVariant.available = checked : currentVariant.available = true;
          this.renderHtml(currentVariant);

          // // 自定义事件，用于监听更改
          this.computeSelectItems(currentVariant)
        }

        // 数量
        if (type == "quantity") {
          const { id } = this.currentVariant;
          this.currentVariant.quantity = value;

          // 更新价格、对比价格、标题、图片
          let currentVariant = this.getCurrentVariant(id);
          // this.renderHtml(currentVariant);

          // // 自定义事件，用于监听更改
          this.computeSelectItems(currentVariant)
          return;
        }

        // 变体切换
        if (type == "variants") {
          let currentVariant = this.getCurrentVariant(value);
          currentVariant.quantity = quantityEl.value

          this.setAttribute("data-id", currentVariant.id);
          // // 数量在产品选中的时候开启编辑
          quantityEl?.toggleAttribute("disabled", false);
          // quantityEl?.classList.toggle("pointer-events-none", !checked);

          // // 更新价格、对比价格、标题、图片
          checked === false ? currentVariant.available = checked : currentVariant.available = true;
          this.renderHtml(currentVariant);

          // // 自定义事件，用于监听更改
          this.computeSelectItems(currentVariant)
        }
      }
    });
  }

  // 获取当前选中的变体
  getCurrentVariant (id) {
    const { priceEl, comparePriceEl } = this.selectsEl;
    const { discountAmount, discountEndTime, discountStartTime } = this.dataset;

    this.currentVariant = Object.assign({
      quantity: this.currentVariant.quantity || 1,
      properties: this.getProperties() || {},
    });

    const { quantity, properties } = this.currentVariant;

    this.currentVariant = Object.assign(
      this.product.variants.find((variant) => variant.id == id)
    );
    return this.currentVariant;
  }

  // 获取属性
  getProperties () {
    let properties = {};
    this.selectsEl.propertiesEl?.forEach((el) => {
      const { value, name } = el;
      properties[name] = value;
    });

    return properties;
  }

  // 更新选中的变体
  renderHtml ({
    available,
    featured_image,
    price,
    compare_at_price,
    title,
    quantity,
    discount,
  }) {
    const {
      inputEl,
      labelEl,
      tagsEl,
      titleEl,
      priceEl,
      discountPriceEl,
      comparePriceEl,
      featuredImageEl,
    } = this.selectsEl;



    if (available === false) {
      this.setAttribute("data-select", false)
    } else {
      this.toggleAttribute("data-select", available);
      this.setAttribute("data-select", true)
      this.toggleAttribute("data-disabled", !available);
      inputEl.checked = available;
      inputEl.toggleAttribute("disabled", !available);
    }

    // this.toggleAttribute("data-disabled", !available);
    // inputEl.checked = available;
    // inputEl.toggleAttribute("disabled", !available);

    // labelEl.classList.toggle("bg-white", available);
    // labelEl.classList.toggle("cursor-pointer", available);
    // labelEl.classList.toggle("cursor-no-drop", !available);
    // labelEl.classList.toggle("bg-gray-50", !available);

    // 切换标签
    // tagsEl.forEach((el) => {
    //   el.classList.add("hidden");
    //   const { tag } = el.dataset;

    //   if (!available && tag == "sold out") {
    //     el.classList.remove("hidden");
    //   }

    //   if (available && tag == "new") {
    //     el.classList.remove("hidden");
    //   }
    // });

    // 变体标题
    if (title != "Default Title") {
      titleEl.textContent = title;
    }

    let newPrice = price * 1;
    let newComparePrice = compare_at_price * 1;

    let num = quantity ? (quantity * 1) : 1

    const discountAmount = discount?.discountAmount;

    // 存在折扣
    if (discountAmount) {
      const isPercentage = discountAmount.includes("%");
      const percentage = Number(discountAmount.replace("%", ""));
      newPrice = isPercentage
        ? price - (price * percentage) / 100
        : price - discountAmount * 100;

      newComparePrice = price;

      // 价格
      priceEl.textContent = formatMoney(newPrice * num, moneyFormat);
      // 对比价格
      comparePriceEl.textContent = formatMoney(
        newComparePrice * num,
        moneyFormat
      );

      // 折扣码价格
      if (discountPriceEl) {
        discountPriceEl.textContent = formatMoney(
          percentage * num * 100,
          moneyFormat
        );
      }
    } else {
      // 价格
      priceEl.textContent = formatMoney(newPrice * num, moneyFormat);
      // 对比价格
      if (comparePriceEl) {
        comparePriceEl.classList.toggle("hidden", newComparePrice <= price);
        comparePriceEl.textContent =
          newComparePrice > price
            ? formatMoney(newComparePrice * num, moneyFormat)
            : '';
      }
    }
    // 图片
    featured_image &&
      featuredImageEl.setAttribute(
        "src",
        featured_image.src
      );
  };

  // 汇总被选中列表
  computeSelectItems (e) {
    this.isCompleted = true;
    const items = this.getSelectItems() || [];
    const { subtotal, compareAtPriceSubtotal, code } = this.computeSubtotal(items);
    this.updateTotalInfo(subtotal, compareAtPriceSubtotal, code)

  }
  updateTotalInfo (subtotal, compareAtPriceSubtotal, code) {
    document.querySelector("#change-total-price .product__price").innerHTML = formatMoney(subtotal, moneyFormat);
    document.querySelector("#change-total-price .product__compare-at-price").innerHTML = formatMoney(compareAtPriceSubtotal, moneyFormat);
    if (code > 0) {
      document.querySelector("#change-total-price .product__compare-at").innerHTML = "-" + formatMoney(code, moneyFormat);;
      document.querySelector("#change-total-price .product__compare-at").style.display = "inline"
    } else {
      document.querySelector("#change-total-price .product__compare-at").style.display = "none"
    }

    document.querySelector(".product-bottom-cta-box .affirm-as-low-as").setAttribute("data-amount", subtotal);
    document.querySelector(".product-bottom-cta-box .affirm-as-low-as").setAttribute("data-sku", '');
    affirm.ui.refresh();
  }
  // 渲染选中的产品
  renderSelectProducts (items) {
    let tempEl = "";
    items.map(({ name, quantity }) => {
      if (name && quantity) {
        tempEl += `<li>${name} *${quantity}<li>`;
      }
    });

    return tempEl;
  }

  // 获取被选中列表
  getSelectItems () {
    const items = [];
    const bundleSelects = document.querySelectorAll('[data-select="true"]');
    // 加入主产品
    const t = Array.from(document.querySelectorAll("[data-options]"));
    let data = t.map(t => Array.from(t.querySelectorAll("input")).find(t => t.checked));
    let obj = {
      price: data[0].dataset.affirm * 1,
      compare_at_price: data[0].dataset.compare_at_price * 1,
      quantity: 1
    }
    items.push(obj);

    // 加入选中的产品
    bundleSelects.forEach((select) => {
      items.push(select.currentVariant);
    });

    return items;
  }

  // 计算选中的产品的总价/总折扣价
  computeSubtotal (items) {
    let subtotal = 0;
    let compareAtPriceSubtotal = 0;
    let code = 0;
    items.map((item) => {
      subtotal += item.price * (item.quantity || 1);
      compareAtPriceSubtotal += item.compare_at_price * (item.quantity || 1);
    });
    code = compareAtPriceSubtotal - subtotal
    return { subtotal, compareAtPriceSubtotal, code };
  }
}

if (!customElements.get("bundle-item")) {
  customElements.define("bundle-item", BundleItem);
}




